/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { Button, ButtonGroup, ModalActions, StyledModal } from 'sarsaparilla';

type BaseModalProps = {
    isOpen: boolean;
    onChange: (v: boolean) => void;
    closeModal: (v?: boolean) => void;
};

export default function NewPreferencesModal({
    isOpen,
    closeModal,
    onChange,
}: BaseModalProps) {
    return (
        <StyledModal
            shouldShowCloseButton
            shouldActionsStickInMobile
            size="md"
            isOpen={isOpen}
            overlayClassName="trip-preferences-modal"
            heading="Trip Preferences"
            onRequestClose={closeModal}
        >
            <p>
                You have never set trip preferences in the past. Would you like to set
                them now?
            </p>
            <ModalActions>
                <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                    <Button appearance="tertiary" onClick={() => closeModal()}>
                        Cancel
                    </Button>
                    <Button onClick={() => onChange(true)}>Proceed</Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}
